export const CLIENT_CIVILITY = Object.freeze({
    M: {
        ID: 0,
        NAME: 'M'
    },
    MMLE: {
        ID: 1,
        NAME: 'Mlle'
    },
    MME: {
        ID: 2,
        NAME: 'Mme'
    },
    SOCIETE: {
        ID: 3,
        NAME: 'Société'
    },
});


// WEBPACK FOOTER //
// ./src/constants/client.js